'use strict';

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('site-modal');
    if (!modal) return;

    // Track forms we've moved into the modal so we can restore them on close
    const movedForms = new Map(); // formId => { wrapper, originalParent, originalNextSibling }

    const openModal = (formId) => {
        modal.querySelectorAll('.modal__form').forEach(f => { f.hidden = true; });

        const slot = modal.querySelector(`[data-form-id="${formId}"]`);
        if (!slot) return;

        // Check if the form already exists on the page outside the modal
        const existingWrapper = document.getElementById(`gform_wrapper_${formId}`);
        if (existingWrapper && !modal.contains(existingWrapper)) {
            // Remove the pre-rendered copy inside the slot to avoid duplicates
            const preRendered = slot.querySelector(`#gform_wrapper_${formId}`);
            if (preRendered) preRendered.remove();

            movedForms.set(formId, {
                wrapper: existingWrapper,
                originalParent: existingWrapper.parentNode,
                originalNextSibling: existingWrapper.nextSibling,
            });
            slot.appendChild(existingWrapper);
        }

        slot.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
    };

    const closeModal = () => {
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');

        // Restore any forms we moved back to their original position
        movedForms.forEach(({ wrapper, originalParent, originalNextSibling }) => {
            originalParent.insertBefore(wrapper, originalNextSibling);
        });
        movedForms.clear();
    };

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-modal-form]');
        if (trigger) openModal(trigger.dataset.modalForm);
    });

    modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-modal-close]')) closeModal();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
});
